import { InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Col, PageHeader, Input, Row, DatePicker } from 'antd';
import PermissionsWrapper from 'app/components/PermissionsWrapper/PermissionsWrapper';
import MapCard from 'app/containers/Map/parts/MapCard/MapCard';
import { MapModeEnum } from 'app/containers/Map/slice/types';
import { PermissionsEnum } from 'app/containers/User/slice/types';
import React, { FC } from 'react';
import { LEFT_COL_WIDTH } from 'utils/constants';
import ShowIfDesktop from 'utils/responsiveQuery/ShowIfDesktop';
import ShowIfMobileOrTablet from 'utils/responsiveQuery/ShowIfMobileOrTablet';
import FieldList from '../../parts/FieldList/FieldList';
import * as S from './FieldListPage.styles';
import { useFieldListPage } from './hooks/useFieldListPage';

type Props = {};

const FieldListPage: FC<Props> = () => {
  const {
    responsivePadding,
    openAddField,
    envId,
    t,
    mobileOrTablet,
    searchQuery,
    setSearchQuery,
    allRoutesDateFilters,
    onAllRoutesDateFilterChange,
  } = useFieldListPage();

  if (!envId) {
    return null;
  }

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Field.List.Fields', 'Fields')}
        extra={[
          <PermissionsWrapper
            key="0"
            requiredEditPermissions={[PermissionsEnum.fieldAdministration]}
          >
            <Button type="primary" onClick={openAddField}>
              {t('Field.List.AddField', 'Add field')}
            </Button>
          </PermissionsWrapper>,
        ]}
      />
      <Row
        wrap={mobileOrTablet}
        gutter={responsivePadding}
        style={{
          paddingLeft: responsivePadding,
          paddingTop: responsivePadding,
          width: '100%',
        }}
      >
        <Col
          style={{
            paddingBottom: 6,
            minWidth: mobileOrTablet ? '100%' : LEFT_COL_WIDTH,
          }}
          order={2}
          lg={{ order: 1 }}
        >
          <ShowIfDesktop>
            <Card bordered={false}>
              <Input
                prefix={<SearchOutlined />}
                suffix={<InfoCircleOutlined />}
                value={searchQuery}
                onChange={e => setSearchQuery(e.currentTarget.value)}
                placeholder={t('Field.List.SearchPlaceholder', 'Search')}
              />
            </Card>

            <Card bordered={false} style={{ marginTop: 12 }}>
              <DatePicker.RangePicker
                style={{ width: '100%' }}
                allowClear
                value={allRoutesDateFilters}
                onChange={onAllRoutesDateFilterChange}
                allowEmpty={[true, true]}
              />
            </Card>
          </ShowIfDesktop>

          <S.DetailsCard bordered={false}>
            <FieldList searchQuery={searchQuery} />
          </S.DetailsCard>
        </Col>

        <S.MapAndResourcesCol
          flex="auto"
          style={{ overflow: 'hidden' }}
          order={1}
          lg={{ order: 2 }}
        >
          <ShowIfMobileOrTablet>
            <Card bordered={false} style={{ marginBottom: 12 }}>
              <Input
                prefix={<SearchOutlined />}
                suffix={<InfoCircleOutlined />}
                value={searchQuery}
                onChange={e => setSearchQuery(e.currentTarget.value)}
                placeholder={t('Field.List.SearchPlaceholder', 'Search')}
              />
            </Card>

            <Card bordered={false} style={{ marginBottom: 12 }}>
              <DatePicker.RangePicker
                style={{ width: '100%' }}
                allowClear
                value={allRoutesDateFilters}
                onChange={onAllRoutesDateFilterChange}
                allowEmpty={[true, true]}
              />
            </Card>
          </ShowIfMobileOrTablet>
          <MapCard mode={MapModeEnum.fieldsAndRoutes} readOnly />
        </S.MapAndResourcesCol>
      </Row>
    </>
  );
};

export default FieldListPage;
